<template>
  <div class="view-profile-notifications">
    <div class="view-profile-notifications__wrapper">
      <app-title-box
        title="Общее"
        class="view-profile-notifications__title"
      ></app-title-box>
      <app-toggler
        title="Уведомления по СМС"
        tooltip="Подсказка"
        id="t10"
        name="Уведомления по СМС"
        class="view-profile-notifications__profile-toggler"
      />
      <app-toggler
        title="Уведомления по почте"
        tooltip="Подсказка"
        name="Уведомления по почте"
        class="view-profile-notifications__profile-toggler"
      />
    </div>
    <div class="view-profile-notifications__wrapper">
      <app-title-box
        title="Заказ"
        class="view-profile-notifications__title"
      ></app-title-box>
      <app-toggler
        title="Измение статуса"
        tooltip="Подсказка"
        name="Измение статуса"
        class="view-profile-notifications__profile-toggler"
      />
      <app-toggler
        title="Новые документы"
        tooltip="Подсказка"
        name="Новые документы"
        class="view-profile-notifications__profile-toggler"
      />
    </div>
    <div class="view-profile-notifications__wrapper">
      <app-title-box
        title="Чат"
        class="view-profile-notifications__title"
      ></app-title-box>
      <app-toggler
        title="Новые сообщения"
        tooltip="Подсказка"
        name="Новые сообщения"
        class="view-profile-notifications__profile-toggler"
      />
      <app-toggler
        title="Предпросмотр сообщения"
        tooltip="Подсказка"
        name="Предпросмотр сообщения"
        class="view-profile-notifications__profile-toggler"
      />
    </div>
  </div>
</template>
<script>
export default {
  name: 'ViewProfileNotifications',
  components: {
    AppTitleBox: () => import('@/components/common/AppTitleBox'),
    AppToggler: () => import('@/components/common/AppToggler'),
  },
};
</script>
<style lang="scss">
.view-profile-notifications {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-start;
  justify-content: flex-start;

  @include media-sm() {
    flex-wrap: wrap;
  }

  &__wrapper {
    flex: 0 0 33%;

    @include media-sm() {
      flex: 0 0 100%;
    }
  }

  &__title {
    margin-bottom: 15px;
  }

  &__profile-toggler {
    flex: 0 0 80%;
    width: 80%;
    margin-bottom: 20px;

    @include media-lg() {
      flex: 0 0 90%;
      width: 90%;
    }

    @include media-sm() {
      flex: 0 0 100%;
      width: 100%;
    }
  }
}

@include media-xs() {
  .app-nav__pane-item {
    padding: 20px;
  }
}
</style>
